'use client';

import Link from 'next/link';
import { AlertTriangle, ArrowUpRight, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { dashboardToneClasses, formatDashboardNumber } from './analytics-dashboard-style';
import type { AnalyticsHubData } from './analytics-dashboard-types';

interface AttentionZoneWidgetProps {
  attention: AnalyticsHubData['attention'];
}

export function AttentionZoneWidget({ attention }: AttentionZoneWidgetProps) {
  return (
    <Card className="rounded-3xl border-[var(--app-border)] bg-[var(--app-surface)] shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <AlertTriangle className="h-4 w-4 text-amber-600" />
          Красная зона
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {attention.length === 0 ? (
          <div className="flex items-center gap-3 rounded-3xl border border-emerald-200 bg-emerald-600 px-4 py-5 text-white">
            <CheckCircle2 className="h-5 w-5 shrink-0" />
            <span className="text-sm font-medium">Критичных зон сейчас не видно</span>
          </div>
        ) : (
          <div className="grid gap-2.5 sm:grid-cols-2 xl:grid-cols-4">
            {attention.map((item) => {
              const tone = dashboardToneClasses(item.tone);
              return (
                <Link
                  key={item.key}
                  href={item.href}
                  className={`rounded-3xl border bg-gradient-to-br p-3 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md ${tone.border} ${tone.gradient}`}
                >
                  <div className="flex items-start justify-between gap-3">
                    <span className={`rounded-2xl px-2.5 py-1 text-xs font-bold ${tone.soft}`}>
                      {formatDashboardNumber(item.value)}
                    </span>
                    <ArrowUpRight className="h-4 w-4 text-[var(--app-text-muted)]" />
                  </div>
                  <p className="mt-3 text-sm font-bold text-[var(--app-text)]">{item.title}</p>
                  <p className="mt-1 line-clamp-2 text-xs leading-snug text-[var(--app-text-soft)]">{item.description}</p>
                </Link>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

